import React from "react";


export default function FloatingBar() {
    return (
        <div className="floating-bar">
            <a href="tel:+919031062013" className="float-call">📞 Call Now</a>
            <a
                href="https://wa.me/919031062013"
                target="_blank"
                rel="noreferrer"
                className="float-whatsapp"
            >
                💬 WhatsApp
            </a>
            <a href="#contact" className="float-book">📋 Book Service</a>
        </div>
    );
}